import React from "react";
import "./PopularVacanciesBanner.module.css";
import CustomLink from "../../components/CustomLink";
import "../../components/CustomLink/CustomLink.css";

function PopularVacanciesBanner(props) {

  return (
    <div className="BannerContainer">
        <h2>популярные вакансии</h2>
        <div className="PopularVacanciesBanner">
            <div className="PopularVacanciesBannerText">
                <h3>Присоединяйся к команде Сервисных инженеров!</h3>
                <img src={require('./img/companies_short.png')}/>
                <ul>
                    <li>Достойная заработная плата</li>
                    <li>Спецодежда и инструменты</li>
                    <li>Гибкий график работы</li>
                    <li>ДМС и бонусы</li>
                </ul>
                <a className="CustomLink" href='https://rabotaertelecom.ru/service'>Оставить заявку</a>
            </div>
        </div>
    </div>
  );
}

export default PopularVacanciesBanner;



// WEBPACK FOOTER //
// ./src/components/PopularVacanciesBanner/index.js